import i18next from 'i18next';

export const convertDateString = (dateStr: any) => {
  const [day, month, year] = dateStr.split("/");
  return i18next.t('dateTime.format.date', { day, month, year });
};

export const countDaysFromDueDate = (dateStr: any) => {
  const [day, month, year] = dateStr.split("/");
  const dueDate: any = new Date(`${year}-${month}-${day}`);
  const today: any = new Date();

  // Xóa phần giờ để chỉ so sánh theo ngày
  dueDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today - dueDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return i18next.t('dateTime.today');
  } else if (diffDays > 0) {
    return i18next.t('dateTime.overdue', { days: diffDays });
  } else {
    return i18next.t('dateTime.remaining', { days: Math.abs(diffDays) });
  }
};

export const convertTimestampToDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000); // Chuyển từ giây sang milliseconds

  const weekdays = [
    i18next.t('dateTime.weekdays.sunday'),
    i18next.t('dateTime.weekdays.monday'),
    i18next.t('dateTime.weekdays.tuesday'),
    i18next.t('dateTime.weekdays.wednesday'),
    i18next.t('dateTime.weekdays.thursday'),
    i18next.t('dateTime.weekdays.friday'),
    i18next.t('dateTime.weekdays.saturday')
  ];

  const months = [
    "1", "2", "3", "4", "5", "6",
    "7", "8", "9", "10", "11", "12"
  ];

  const weekday = weekdays[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return i18next.t('dateTime.format.datetime', {
    weekday,
    day,
    month,
    year,
    hours,
    minutes,
    ampm
  });
};

export const getRemainingTime = (duedate: number) => {
  const now = new Date().getTime();
  const due = duedate * 1000; // đổi sang milliseconds
  const diff = due - now;

  if (diff <= 0) return i18next.t('dateTime.expired');

  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  const parts = [];
  if (days > 0) parts.push(i18next.t('dateTime.days', { count: days }));
  if (hours > 0) parts.push(i18next.t('dateTime.hours', { count: hours }));
  if (minutes > 0) parts.push(i18next.t('dateTime.minutes', { count: minutes }));

  return i18next.t('dateTime.remainingTime', { time: parts.join(" ") });
};

export function formatTime(seconds: any) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    secs.toString().padStart(2, "0"),
  ].join(":");
}
